import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import classes from './QuestionTextOld.module.css'
import useAutosizeTextArea from "../../../../hooks/useAutosizeTextArea"
import { calculateScore } from "../../../utils";

const QuestionText = ({
    points,
    longAnswer,
    completed,
    correctAnswers,
    handleChangeAnsData,
    submission,
    statusObject,
    scoreByRetries,
    id,
    ansData,
    sendInProgress,
    index }) => {

    const [value, setValue] = useState('');
    const [valueChanged, setValueChanged] = useState(false);
    const { texts, direction } = useSelector(state => state.translate);

    const textareaRef = useRef();

    useAutosizeTextArea(textareaRef.current, value);

    useEffect(() => {
        if (valueChanged) {
            const correct = correctAnswers.some(ans => ans === value.trim());
            const correctText = <div>{correctAnswers.map(ans => <div className={classes.CorrectAnsFeedback}>{ans} </div>)} </div>
            handleChangeAnsData({
                id: id,
                correct: correct,
                correctText: correctText,
                solution: value !== "" ? value : null,
                score: calculateScore(correct, submission?.attempts + 1 || 0, statusObject.retryConditions, scoreByRetries, points),
                success: correct ? correct : longAnswer ? null : false
            })
        }
    }, [value]);

    useEffect(() => {
        if(ansData?.solution){
            setValue(ansData.solution)
        }
        else if (submission) {
            setValueChanged(false)
            setValue(submission.solution)
        }
    }, [submission, id, index])

    const handleChange = (e) => {
        setValue(e.target.value)
        setValueChanged(true)
    }


    return <div className={classes.QuestionText}>
        {longAnswer ?
            <textarea disabled={completed || sendInProgress} ref={textareaRef} onChange={handleChange} value={value} className={`${classes[direction]} ${classes.AnsDemo}`} placeholder={texts.answer}></textarea> :
            <input disabled={completed || sendInProgress} onChange={handleChange} value={value} className={classes.AnsDemo} placeholder={texts.answer} type='text'></input>
        }
        <div className={classes.Pen}></div>
    </div>
}
export default QuestionText;